import { HandleNewDreamEditorLaunch } from "source/app/presentation/MainPanel/Dreams/Add/Helpers/HandleNewDreamEditorLaunch";
import { GetSelectedDreamAttribute } from "source/app/presentation/MainPanel/Dreams/Add/NewDream/Link/ShowNewDreamLink";
import { IDreamsState } from "source/app/presentation/MainPanel/Dreams/IDreamsState";
import { IActivePanelState } from "source/app/presentation/Shared/ActivePanel/IActivePanelState";
import { EPanelId } from "source/app/services/Shared/EPanelId";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";

export function HandleCreateNewItemHotkey() {
    const activePanel = State.ReadClass<IActivePanelState>(
        ESharedComponent.ActivePanel
    );

    if (!activePanel) {
        return;
    }

    const { activePanelId } = activePanel.state;

    if (activePanelId === EPanelId.Dreams) {
        const dreams = State.ReadClass<IDreamsState>(ESharedComponent.Dreams);

        if (dreams !== undefined) {
            const selectedDreamAttribute = GetSelectedDreamAttribute(
                dreams.state
            );

            HandleNewDreamEditorLaunch(
                selectedDreamAttribute,
                dreams.state
            );
        }
    }
}
